/**
 * @fileoverview View component of the ReduxModal, don't have any logic inside and completely controled by container component
 */
import React from 'react'

import Modal from '@material-ui/core/Modal'
import { makeStyles } from '@material-ui/core/styles'
import { ModalHeader } from '../../../Components/Modal/ModalHeader'
import { ModalTitle } from '../../../Components/Modal/ModalTitle'
import { ModalBody } from '../../../Components/Modal/ModalBody'
import { ModalFooter } from '../../../Components/Modal/ModalFooter'
import SubmitButton from 'Components/Form/SubmitButton'

const useStyles = makeStyles(theme => ({
  modalWrapper: {
    flexGrow: 1,
  },
  container: {
    width: 600,
    background: 'white',
    borderRadius: '4px',
    boxShadow: 'none',
    height: 'min-content',
    margin: '100px auto',
    maxHeight: '70vh',
    overflow: 'scroll',
  },
}))

/**
 * Renders styled modal view for ReduxModal
 *
 * @param {boolean} props.show Indicates whether modal should be visible
 * @param {string} props.title Modal's title
 * @param {function} props.handleConfirm Action of the confirm button
 * @param {string} props.confirmLabel Label of the confirm button
 * @param {function} props.handleCancel Action of the cancel button
 * @param {string} props.cancelLabel Label of the cancel button
 * @param {array} props.children Component's children that will be rendered in the middle of the view
 * @param {boolean} props.confirmDisabled Indicates whether confirm button should be disabled
 * @param {boolean} props.hideCancel Indicates whether cancel button should be hidden
 * @param {boolean} props.hideTitle Indicates whether title should be hidden
 * @param {boolean} props.hideButtons Indicates whether all footer buttons should be hidden
 *
 * @returns {JSX.Element}
 */
const ReduxModalView = ({
  show,
  title,
  handleConfirm,
  confirmLabel = 'Confirm',
  handleCancel,
  cancelLabel = 'Cancel',
  children,
  confirmDisabled,
  hideCancel = false,
  hideTitle = false,
  hideButtons = false,
}) => {
  const classes = useStyles()

  return (
    <Modal open={show} disableEnforceFocus className={classes.modalWrapper}>
      <div className={classes.container}>
        {!hideTitle && (
          <ModalHeader>
            <ModalTitle>{title}</ModalTitle>
          </ModalHeader>
        )}
        <ModalBody>{children}</ModalBody>
        {!hideButtons && (
          <ModalFooter>
            {!hideCancel && (
              <SubmitButton
                value="cancel"
                label={cancelLabel}
                onClick={handleCancel}
              />
            )}
            <SubmitButton
              disabled={confirmDisabled}
              value={confirmLabel}
              onClick={handleConfirm}
            />
          </ModalFooter>
        )}
      </div>
    </Modal>
  )
}

export default ReduxModalView



// WEBPACK FOOTER //
// ./src/Components/ReduxModal/component/ReduxModalView.js